import { ComponentProps } from "react";

export const DevicesIcon = (props: ComponentProps<"svg">) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.49711 2.25722C8.80084 1.4979 9.53626 1 10.3541 1H13.6459C14.4637 1 15.1992 1.4979 15.5029 2.25722L16.619 5.04761C18.5342 5.34516 20 7.0014 20 9V15C20 16.9986 18.5342 18.6548 16.619 18.9524L15.5029 21.7428C15.1992 22.5021 14.4637 23 13.6459 23H10.3541C9.53626 23 8.80084 22.5021 8.49711 21.7428L7.38096 18.9524C5.46577 18.6548 4 16.9986 4 15V9C4 7.0014 5.46577 5.34516 7.38096 5.04761L8.49711 2.25722ZM12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z"
      fill={props.fill || "#1E145D"}
    />
  </svg>
);
